import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../../components/Layout'
import NewsListTemplate from '../../components/NewListTemplate'

const prepareProfiles = (edges)=>{

  return edges.map(edge=>{
    const {frontmatter,excerpt,html,fields}=edge.node;
    const link = fields.slug;
    return {description:html,excerpt,link,...frontmatter}
  })
}


const Component = ({ data }) => {
  const results = data.allMarkdownRemark.edges;
  const newsList= prepareProfiles(results)
  return (
    <Layout>
      <NewsListTemplate
        newsList={newsList}
      />
    </Layout>
  )
}

Component.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: {
      edges:PropTypes.array
    },
  }),
}

export default Component

export const PageQuery = graphql`
  query {allMarkdownRemark(filter:{
  frontmatter:{
    templateKey:{
      eq:"blog-post"
    }
  }
}){
  edges{
    node{
      html
      excerpt(pruneLength:200)
      fields{
        slug
      }
      frontmatter{
        title
        image{
          src
          alt
        }
      }
    }
  }
}
}
`
